module.exports = __webpack_public_path__ + "img/Api.701b548 2.8a22a89.svg";